import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import ScorecardSchemeLabelSource from 'sources/scorecards/ScorecardSchemeLabelSource';

class ScorecardSchemeLabelActions {
  constructor() {
    this.generateActions(...generateAsyncActions('labels', 'save'));
  }

  labels() {
    return dispatch => {
      dispatch();
      return ScorecardSchemeLabelSource.labels().then(this.labelsSuccess, this.labelsError);
    };
  }

  save(labels) {
    return dispatch => {
      dispatch(labels);
      return ScorecardSchemeLabelSource.save(labels).then(
        this.saveLabelsSuccess,
        this.saveLabelsError
      );
    };
  }
}

export default alt.createActions(ScorecardSchemeLabelActions);
